import type { PostApiV1ThreeLetterCodePartnerAdminsUsersBody } from '@fukuri-admins/apis/client/gen/model';
import { formatDate } from '@fukuri-admins/utils/common/date';
import type { CreateUserFormFieldValues } from '../schema';

type Args = {
  formValues: CreateUserFormFieldValues;
};

type IGenerateRequest = (args: Args) => PostApiV1ThreeLetterCodePartnerAdminsUsersBody;

/**
 * 利用者追加フォームの値からAPIリクエストボディを生成する
 *
 * @param args.formValues - フォームの入力値
 * @returns APIリクエストボディ
 */
export const generateRequest: IGenerateRequest = ({ formValues }) => ({
  user: {
    client_id: Number(formValues.clientId),
    full_name: formValues.fullName,
    email: formValues.email,
    external_user_id: formValues.externalUserId ?? '',
    password: formValues.password,
    password_confirmation: formValues.passwordConfirmation,
    // billableFrom は Zod スキーマ（userFormSchema）で必須バリデーション済みかつ
    // .transform で Date 型に絞り込み済みのため、null 分岐は不要で常に送信する。
    billable_from: formatDate({ date: formValues.billableFrom, formatType: 'yyyy-MM-dd' }),
  },
});
